<template>
    <input
        v-if="
            filter.current_shortcut_key != 'is_done' &&
            filter.current_shortcut_key != 'is_canceled' &&
            filter.current_shortcut_key != 'customer_identity' &&
            filter.current_shortcut_key != 'created_duration'
        "
        @keypress.enter="$parent.$parent.$parent.operations_filter()"
        v-model="filter.columns[filter.current_shortcut_key]"
        :placeholder="$t('ui.general.search__key', {
            key: $t('models.attributes.operations.'+filter.current_shortcut_key)
        })"
        type="text"
    >

    <!--
    * ========================================================================
    * = 自行定義
    * ========================================================================
    -->
    <DatePicker
        v-else-if="filter.current_shortcut_key == 'created_duration'"
        v-model="filter.columns.created_duration"
        style="min-width: 200px;width:100%;"
        type="daterange"
        format="YYYY-MM-DD"
        key="created_duration">
    </DatePicker>
    <div
        v-else-if="filter.current_shortcut_key == 'customer_identity'"
        class="ui selection fluid dropdown right_radius"
        style="min-width: 200px;"
        v-dropdown>
        <div class="text"
            v-for="customer in customers"
            v-if="filter.columns.customer_identity == customer.identity">
            {{ customer.company_name }}
        </div>
        <i class="dropdown icon"></i>
        <div class="menu">
            <div
                v-for="customer in customers"
                @click="filter.columns.customer_identity = customer.identity"
                class="item"
                :class="{
                    'selected active': filter.columns.customer_identity == customer.identity
                }">
                {{ customer.company_name }}
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    name: "OperationsFilterHeaderInputs",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.operations_module
        },
        filter() {
            return this.current_store.filter
        },
        customers() {
            return [{
                company_name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.customers)
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        DatePicker
    }
}
</script>

<style scoped lang="scss">
    .right_radius, .right_radius input {
        border-bottom-right-radius: 0px !important;
        border-top-right-radius: 0px !important;
    }
</style>
